import {
  WorksheetBatchUpdateCommonDefaultParams,
  WorksheetBatchUpdateCommonQueryFields,
  WorksheetBatchUpdateCommonRequiredParams,
} from 'Components/WorksheetBatchUpdate/Core/SharedQueryFields';
import { WorksheetBatchUpdateDefinition } from '../..';
import {
  ArizNuclearFieldDensityWorksheetFields,
  ArizNuclearFieldDensityWorksheetSections,
} from './ArizNuclearFieldDensityWorksheetFields';

const ArizNuclearFieldDensityBatchUpdateDefinition: WorksheetBatchUpdateDefinition = {
  worksheetType: 'Nuclear Field Density',
  query: {
    defaultParams: WorksheetBatchUpdateCommonDefaultParams,
    requiredParams: WorksheetBatchUpdateCommonRequiredParams,
  },
  queryFields: WorksheetBatchUpdateCommonQueryFields,
  worksheetFields: ArizNuclearFieldDensityWorksheetFields,
  worksheetFieldSections: ArizNuclearFieldDensityWorksheetSections,
};

export default ArizNuclearFieldDensityBatchUpdateDefinition;

export { ArizNuclearFieldDensityBatchUpdateDefinition };
